import React, { Fragment, useEffect, useRef, useState } from "react";
import { Row, Col, Select, Input, TextArea, Button, Slider, CountryDropdown, Toast } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import Styles from './index.module.scss';
import { ISandboxRequest, IWhatsappSandboxResponse, sandboxKeyType } from "../../../../../../store/models/whatsappSandbox.interface";
import { cloneDeep, isEmpty } from "lodash";
import { validatePhoneNumber } from "../../../../../../utils";

export type DispatchPropsType = {
    onClose: () => void;
    onLoad: () => void;
    onChange: (fields: { name: sandboxKeyType; value: any }) => void;
    onSave: (reqObj: ISandboxRequest, callback: (resp: any, flag: boolean) => void) => void;
    setSandboxState: (tempObj: Partial<Record<sandboxKeyType, any>>) => void;
    fetchCountryList: () => void;

};


export type MapStateType = {
    sandbox: any;
    data: any;
    countryList: any[];
};

type OptionType = {
    label: string;
    value: string;
};

var setInitial: boolean = true

const Sandbox: React.FC<DispatchPropsType & MapStateType> = ({
    onClose,
    onLoad,
    onChange,
    onSave,
    fetchCountryList,
    setSandboxState,
    countryList,
    data,
    sandbox
}) => {

    const { t } = useTranslation();
    const [countries, setCountries] = useState<any>([]);
    const [template, setTemplate] = useState<any>();
    const { sandbox: sandboxLayoutData } = (data.sandbox && data) || { sandbox: {} };
    var [numberText, setNumberText] = useState<string>();

    const numberSetStateRef = useRef(setNumberText)
    const numberStateRef = useRef(numberText)
    const callButtonNumber = template?.call_button_number

    useEffect(() => {
        numberStateRef.current = numberText
    }, [numberText, callButtonNumber])

    useEffect(() => {
        onLoad();
        fetchCountryList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setInitial && !isEmpty(sandboxLayoutData) && setInitialState()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.sandbox])




    useEffect(() => {
        if (Array.isArray(countryList)) {
            let country = countryList.map((item: any) => ({
                "countryid": item.country_id,
                "name": item.name,
                "code": item.code,
                "isoCode": item.iso_code
            }))
            setCountries([...country])
        }
    }, [countryList])



    const setInitialState = () => {
        let templateType = sandboxLayoutData?.sandbox_template_type && Object.keys(sandboxLayoutData?.sandbox_template_type)[0];
        let templateBody = templateType && sandboxLayoutData?.sandbox_message[templateType].message
        let params: string[] = []
        if (sandboxLayoutData?.sandbox_message[templateType]?.params)
            params.length = sandboxLayoutData?.sandbox_message[templateType]?.params
        setSandboxState({
            'template_type': templateType,
            'from': sandboxLayoutData?.sandbox_numbers && Object.keys(sandboxLayoutData?.sandbox_numbers)[0],
            'templates_json': sandboxLayoutData?.templates_json && JSON.parse(sandboxLayoutData?.templates_json),
            'template_body': templateBody,
            'country_code': 'in',
            'country_dialcode': '91',
            'params': params,
        })
        setInitial = false;
    }

    const onLocalChange = (
        name: sandboxKeyType,
        isCustom: boolean = false
    ) => (value: any) => {
        onChange({
            name,
            value: isCustom
                ? (value as React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                >).target.value
                : value,
        });
    };

    const onTemplateTypeChange = (
        name: sandboxKeyType,
        isCustom: boolean = false
    ) => (value: any) => {
        let templateType = value;
        let templateBody = sandboxLayoutData?.sandbox_message[value].message
        let params = sandbox.params
        params.length = sandboxLayoutData?.sandbox_message[value].params
        setTemplate(sandboxLayoutData?.sandbox_message[value])
        setSandboxState({
            ...sandbox,
            'template_type': templateType,
            'template_body': templateBody,
        })
    };

    const onParamsChange = (
        name: sandboxKeyType,
        index: number
    ) => (value: any) => {
        let tempParams = [...sandbox?.params];
        tempParams[index] = (value as React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement
        >).target.value
        onChange({
            name,
            value: [...tempParams]
        })
    };

    const onNumberChange = (
        name: sandboxKeyType,
        isCustom: boolean = false
    ) => (value: any, code: string) => {
        if (code !== sandbox.country_code) {
            let countryDetails = countries.find((item: any) => item.code === code);
            if (countryDetails) {
                onChange({ name: 'country_code', value: countryDetails.isoCode })
                onChange({ name: 'country_dialcode', value: countryDetails.code })
            }
        }
        numberSetStateRef.current(isCustom
            ? (value as React.ChangeEvent<
                HTMLInputElement | HTMLTextAreaElement
            >).target.value
            : value)
        onChange({
            name,
            value: isCustom
                ? (value as React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                >).target.value
                : value,
        });
    };

    const getOptions = (key: string): OptionType[] => {
        let options: OptionType[] = [];
        let keyOptions: Record<string, any>;
        switch (key) {
            case 'template_type':
                keyOptions = sandboxLayoutData?.sandbox_template_type ? { ...sandboxLayoutData?.sandbox_template_type } : {};
                break;
            case 'numbers':
                keyOptions = sandboxLayoutData?.sandbox_numbers ? { ...sandboxLayoutData?.sandbox_numbers } : {};
                break;
            default:
                keyOptions = {};
                break;
        }
        Object.keys(keyOptions).forEach((key: string) => {
            options.push({
                label: keyOptions[key],
                value: key
            })
        })
        return options;
    }

    const callback = (res: IWhatsappSandboxResponse, flag: boolean): void => {
        if (flag && res.data && isEmpty(res.error)) {
            Toast(t('mainMessageSent'), 'success')
            onClose();
            onLoad();
        } else if (!isEmpty(res?.error)) {
            Object.keys(res.error).forEach((key: any) => {
                Toast(res.error[key], 'error');
            });
        } else {
            Toast(res?.message, 'error');
        }
    }

    const getRequestObj = (): ISandboxRequest => {
        let tempSandbox_message = (!isEmpty(sandboxLayoutData?.sandbox_message) && cloneDeep(sandboxLayoutData?.sandbox_message)) || {}
        Object.keys(tempSandbox_message).forEach(key => {
            tempSandbox_message[key].param_count = tempSandbox_message[key].params;
            delete tempSandbox_message[key].params
            delete tempSandbox_message[key].type
        })
        return ({
            "templates_json": JSON.stringify(tempSandbox_message),
            "namespace": "",
            "from": sandbox.from,
            "mobile_number": sandbox.mobile_number,
            "country_code": sandbox.country_code,
            "country_dialcode": sandbox.country_dialcode,
            "template_type": sandbox.template_type,
            "params": sandbox.params
        })
    }

    const validateFields = () => {
        let isParamsEmpty: number = 0;
        sandbox.params.forEach((item: string, index: number) => {
            if (!item) isParamsEmpty = index + 1;
        })
        if (!sandbox.mobile_number) {
            Toast(t("BLD01541"), "error");
            return false;
        }
        if (sandbox.mobile_number && !validatePhoneNumber(sandbox.mobile_number)) {
            Toast(t("BLD01542"), "error");
            return false;
        }

        if (isParamsEmpty) {
            let errMsg = t("BLD01621").replace('#NUM', isParamsEmpty.toString())
            Toast(errMsg, "error");
            return false;
        }

        return true
    }

    const onClickSave = () => {
        let reqObj: ISandboxRequest
        reqObj = getRequestObj();
        if (!validateFields()) return;
        onSave(reqObj, callback)

    }

    const getBody = () => {
        return <Fragment>
            <div>
                <p className={Styles.message}>{t('RBC1433')}</p>
                <div className={Styles.section}>
                    <Row>
                        <Col size={12}>
                            <Select options={getOptions('numbers')}
                                value={sandbox?.from}
                                onChange={onLocalChange('from')}
                                label={t('BLD00530')} placeholder={t('BLD00530')}
                                showBottomLabelSpace={false}
                                className={Styles.formField}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col size={12}>
                            <CountryDropdown
                                data={countries}
                                mode="iso"
                                label={t('BLD00531')}
                                placeholder={t('BLD00531')}
                                onChange={onNumberChange('mobile_number', true)}
                                defaultSelectValue={sandbox?.country_dialcode}
                                value={numberStateRef.current}
                            />
                        </Col>
                    </Row>
                </div>
                <div className={Styles.section}>
                    <p className={Styles.sectionHeading}>{t('BLD00428')}</p>
                    <Row>
                        <Col size={12}>
                            <Select
                                options={getOptions('template_type')}
                                label={t('mainSelectTemplate')}
                                value={sandbox?.template_type}
                                placeholder={t('mainSelectTemplate')}
                                onChange={onTemplateTypeChange('template_type')}
                                showBottomLabelSpace={false}
                                className={Styles.formField}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col size={12}>
                            <TextArea value={sandbox?.template_body}
                                onChange={onLocalChange('template_body', true)}
                                placeholder={t('BLD00428')}
                                label={t('BLD00428')}
                                disabled
                                showBottomLabelSpace={false}
                                className={Styles.formField}
                            />
                        </Col>
                    </Row>
                </div>
                <div className={Styles.section}>
                    <p className={Styles.sectionHeading}>{t('BLD00533')}</p>
                    <Row>
                        {
                            sandbox?.params?.map((item: string, index: number) => <Col key={'params-' + index} size={12}>
                                <Input
                                    value={item}
                                    onChange={onParamsChange('params', index)}
                                    placeholder={"Param" + (index + 1)}
                                    label={"Param" + (index + 1)}
                                    showBottomLabelSpace={false}
                                    className={Styles.formField}
                                />
                            </Col>
                            )
                        }

                    </Row>
                </div>
            </div>
        </Fragment>
    };

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={onClickSave}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            footer={getFooter()}
            title="Sandbox"
        >
            {getBody()}
        </Slider>
    );


}

export default Sandbox;